import { Outlet } from "react-router";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { overlayVariants } from "../../../utils/framerMotion";
import AgentSidebar from "./sidebar";
import AgentNavbar from "./navbar";

const AgentHomeLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <div className="flex min-h-screen w-full bg-[#0D0C0B]">
      <AnimatePresence>
        {isSidebarOpen && (
          <motion.div
            variants={overlayVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="fixed inset-0 bg-black/60 z-20 lg:hidden backdrop-blur-sm"
            onClick={toggleSidebar}
          />
        )}
      </AnimatePresence>

      <AgentSidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        onCollapseChange={setIsSidebarCollapsed}
      />

      <div
        className={`flex flex-col flex-1 min-w-0 transition-all duration-300 ${
          isSidebarCollapsed ? "lg:ml-16" : "lg:ml-64"
        }`}
      >
        <AgentNavbar
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
        />

        <main className="flex-1 p-4 overflow-x-auto text-[#F1EDE4]">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AgentHomeLayout;
